package com.schoolconnect.app.feature.mystudents

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.horizontalScroll
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.RowScope
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.Button
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.DropdownMenuItem
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedButton
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.layout.onGloballyPositioned
import androidx.compose.ui.platform.LocalDensity
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.schoolconnect.app.designsystem.AppBackground
import com.schoolconnect.app.designsystem.AppPageHeader
import com.schoolconnect.app.designsystem.AppPageSubtitle
import com.schoolconnect.app.designsystem.AppCard
import com.schoolconnect.app.designsystem.AppButton
import com.schoolconnect.app.designsystem.AppOutlinedButton
import com.schoolconnect.app.designsystem.AppBorder
import com.schoolconnect.app.designsystem.AppDanger
import com.schoolconnect.app.designsystem.AppDangerSoft
import com.schoolconnect.app.designsystem.AppMuted
import com.schoolconnect.app.designsystem.AppNavy
import com.schoolconnect.app.designsystem.AppPrimary
import com.schoolconnect.app.designsystem.AppPrimarySoft
import com.schoolconnect.app.designsystem.AppSuccess
import com.schoolconnect.app.designsystem.AppSuccessSoft
import com.schoolconnect.app.designsystem.AppDropdownMenu
import com.schoolconnect.app.repository.systemlookup.SystemLookupRepository
import com.schoolconnect.app.designsystem.AppDialogActionStyle
import com.schoolconnect.app.designsystem.AppDialogDefaultColors
import com.schoolconnect.app.designsystem.AppDialogErrorMessage
import com.schoolconnect.app.designsystem.AppDialogDateField
import com.schoolconnect.app.designsystem.AppDialogFooter
import com.schoolconnect.app.designsystem.AppDialogFooterAction
import com.schoolconnect.app.designsystem.AppDialogHeader
import com.schoolconnect.app.designsystem.AppDialogScaffold
import com.schoolconnect.app.designsystem.AppDialogSize
import com.schoolconnect.app.designsystem.list.AdminListFooter
import com.schoolconnect.app.designsystem.list.AdminListEmptyState
import com.schoolconnect.app.designsystem.list.AdminListActionIcons
import com.schoolconnect.app.designsystem.list.AdminListHeaderColumn
import com.schoolconnect.app.designsystem.list.AdminListPageScaffold
import com.schoolconnect.app.designsystem.list.AdminListSearchField
import com.schoolconnect.app.designsystem.list.AdminRowActionItem
import com.schoolconnect.app.designsystem.list.AdminRowActionMenu
import com.schoolconnect.app.designsystem.list.AdminListSummaryCard
import com.schoolconnect.app.designsystem.list.AdminListTableBody
import com.schoolconnect.app.designsystem.list.AdminListTableBodyText
import com.schoolconnect.app.designsystem.list.AdminListTableCard
import com.schoolconnect.app.designsystem.list.AdminListTableShimmer
import com.schoolconnect.app.designsystem.list.AdminListSummaryCardsShimmer
import com.schoolconnect.app.designsystem.list.AdminListHeaderRow
import com.schoolconnect.app.designsystem.list.AdminListSortColumn
import com.schoolconnect.app.designsystem.list.AdminListSortHeaderRow
import com.schoolconnect.app.designsystem.list.DesktopAwareLazyColumn
import com.schoolconnect.app.designsystem.list.onViewDoubleClick
import com.schoolconnect.app.feature.common.ShellTopRightActions
import com.schoolconnect.app.feature.common.shellAvatarInitials
import com.schoolconnect.app.feature.common.shellRoleLabel
import com.schoolconnect.app.feature.common.shellRoleSubtitle
import com.schoolconnect.app.feature.common.pageFooterText
import com.schoolconnect.app.feature.common.pageWindow
import com.schoolconnect.app.feature.common.PaginationPolicy
import com.schoolconnect.app.feature.attendance.AttendanceHistoryDialog
import com.schoolconnect.app.feature.attendance.AttendanceInsightRowUi
import com.schoolconnect.app.feature.students.StudentViewModal
import com.schoolconnect.app.feature.parentnotes.AddParentNoteDialog
import com.schoolconnect.app.feature.parentnotes.ParentNoteStudentPrefill
import com.schoolconnect.app.feature.parentnotes.ParentNoteStudentOption
import com.schoolconnect.app.feature.parentnotes.ParentNotesUiEvent
import com.schoolconnect.app.feature.parentnotes.ParentNotesViewModel
import ischoolconnect.sharedui.generated.resources.Res
import ischoolconnect.sharedui.generated.resources.calendar
import ischoolconnect.sharedui.generated.resources.chevron_down
import ischoolconnect.sharedui.generated.resources.close_x
import ischoolconnect.sharedui.generated.resources.activity_calendar
import ischoolconnect.sharedui.generated.resources.document
import ischoolconnect.sharedui.generated.resources.chart_square
import ischoolconnect.sharedui.generated.resources.health_chart
import ischoolconnect.sharedui.generated.resources.clipboard_check
import ischoolconnect.sharedui.generated.resources.message
import ischoolconnect.sharedui.generated.resources.stat_students
import ischoolconnect.sharedui.generated.resources.user
import ischoolconnect.sharedui.generated.resources.filter
import ischoolconnect.sharedui.generated.resources.more_vertical
import ischoolconnect.sharedui.generated.resources.users
import org.jetbrains.compose.resources.painterResource
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import kotlinx.coroutines.yield

private val MyStudentsWarning = Color(0xFFFF9800)
private val MyStudentsWarningSoft = Color(0xFFFFF3E0)
private val MyStudentsDanger = Color(0xFFE53935)
private val MyStudentsDangerSoft = Color(0xFFFFEBEE)

@Composable
fun TeacherMyStudentsScreen(
    state: MyStudentsUiState,
    onEvent: (MyStudentsUiEvent) -> Unit,
    onBack: () -> Unit = {},
    shellRoleCode: String = "",
    shellSchoolLabel: String = "iConnect.School",
    onChangeRole: () -> Unit = onBack,
    onLogout: () -> Unit = {},
    showShellHeaderActions: Boolean = true
) {
    var profileExpanded by remember { mutableStateOf(false) }
    var rowsPerPageExpanded by remember { mutableStateOf(false) }
    var selectedStudent by remember { mutableStateOf<MyStudentRowUi?>(null) }
    var selectedAttendanceStudent by remember { mutableStateOf<MyStudentRowUi?>(null) }
    var selectedExamResultsStudent by remember { mutableStateOf<MyStudentRowUi?>(null) }
    var selectedParentNoteStudent by remember { mutableStateOf<MyStudentRowUi?>(null) }
    val parentNotesViewModel = remember { ParentNotesViewModel(autoLoad = false) }
    val parentNotesState by parentNotesViewModel.uiState.collectAsState()
    DisposableEffect(parentNotesViewModel) {
        onDispose { parentNotesViewModel.clear() }
    }
    val window = pageWindow(state.pageIndex, state.pageSize, state.totalCount)
    val safePageIndex = window.pageIndex
    val pageItems = state.rows

    Box(modifier = Modifier.fillMaxSize()) {
        AdminListPageScaffold(
        title = "My Students",
        subtitle = "Track student performance across your assigned classes.",
        backgroundColor = AppBackground,
        titleColor = AppPageHeader,
        subtitleColor = AppPageSubtitle,
        headerActions = if (showShellHeaderActions) {
            {
                ShellTopRightActions(
                    roleLabel = shellRoleLabel(shellRoleCode),
                    roleSubtitle = shellRoleSubtitle(shellRoleCode),
                    initials = shellAvatarInitials(shellRoleLabel(shellRoleCode)),
                    expanded = profileExpanded,
                    onExpandedChange = { profileExpanded = it },
                    onChangeRole = onChangeRole,
                    onLogout = onLogout
                )
            }
        } else {
            {}
        },
        summaryCards = {
            if (state.isLoading && state.rows.isEmpty()) {
                AdminListSummaryCardsShimmer(cardCount = 4)
            } else {
                MyStudentsSummaryCard("Total Students", state.totalStudents.toString(), "Across all classes", Res.drawable.users, AppPrimary, AppPrimarySoft)
                MyStudentsSummaryCard("Assigned Classes", state.assignedClasses.toString(), state.classOptions.take(3).joinToString(", ") { it.label }.ifBlank { "No classes assigned" }, Res.drawable.calendar, AppSuccess, AppSuccessSoft)
                MyStudentsSummaryCard("Good Performance", state.goodPerformance?.toString() ?: "—", "Average score ≥ 70%", Res.drawable.stat_students, MyStudentsWarning, MyStudentsWarningSoft)
                MyStudentsSummaryCard("Needs Attention", state.needsAttention?.toString() ?: "—", "Average score < 40%", Res.drawable.filter, MyStudentsDanger, MyStudentsDangerSoft)
            }
        },
        // API failures are presented once by the global error alert host.
        // Keeping a second copy here would duplicate the same error on the page.
        banner = {},
        toolbar = {
            MyStudentsFilterPanel(
                state = state,
                onEvent = onEvent
            )
        },
        table = { modifier ->
            AdminListTableCard(
                modifier = modifier,
                surfaceColor = Color.White,
                borderColor = AppBorder,
                // Keep the table readable on compact windows. AdminListTableCard
                // provides the horizontal scrollbar when this width exceeds the
                // available viewport instead of truncating the Performance cell.
                minContentWidth = 1240.dp,
                header = {
                    AdminListSortHeaderRow(listOf(
                        AdminListSortColumn("Roll No", .8f, state.sortField == MyStudentsSortField.ROLL_NUMBER, state.sortAscending) { onEvent(MyStudentsUiEvent.SortChanged(MyStudentsSortField.ROLL_NUMBER)) },
                        AdminListSortColumn("Student Name", 1.45f, state.sortField == MyStudentsSortField.STUDENT_NAME, state.sortAscending) { onEvent(MyStudentsUiEvent.SortChanged(MyStudentsSortField.STUDENT_NAME)) },
                        AdminListSortColumn("Class", .9f, state.sortField == MyStudentsSortField.CLASS, state.sortAscending) { onEvent(MyStudentsUiEvent.SortChanged(MyStudentsSortField.CLASS)) },
                        AdminListSortColumn("Gender", .9f, state.sortField == MyStudentsSortField.GENDER, state.sortAscending) { onEvent(MyStudentsUiEvent.SortChanged(MyStudentsSortField.GENDER)) },
                        AdminListSortColumn("Attendance", 1.1f, state.sortField == MyStudentsSortField.ATTENDANCE, state.sortAscending) { onEvent(MyStudentsUiEvent.SortChanged(MyStudentsSortField.ATTENDANCE)) },
                        AdminListSortColumn("Performance", 1.15f, state.sortField == MyStudentsSortField.PERFORMANCE, state.sortAscending) { onEvent(MyStudentsUiEvent.SortChanged(MyStudentsSortField.PERFORMANCE)) }
                    ), actionsLabel = "Actions", actionsWeight = .95f, actionsAlignment = Alignment.Center)
                },
                body = {
                    if (state.isLoading) {
                        AdminListTableShimmer(columns = listOf(
                            AdminListHeaderColumn("Roll No", .8f), AdminListHeaderColumn("Student Name", 1.45f), AdminListHeaderColumn("Class", .9f), AdminListHeaderColumn("Gender", .9f), AdminListHeaderColumn("Attendance", 1.1f), AdminListHeaderColumn("Performance", 1.15f), AdminListHeaderColumn("Actions", .95f)
                        ), rowCount = state.pageSize)
                    } else if (pageItems.isEmpty()) {
                        Box(Modifier.fillMaxWidth().weight(1f), contentAlignment = Alignment.Center) {
                            AdminListEmptyState(
                                title = "No students found",
                                subtitle = "Try adjusting your search or filters."
                            )
                        }
                    } else {
                        AdminListTableBody(items = pageItems, key = { it.key }, modifier = Modifier.fillMaxWidth().weight(1f)) { row ->
                            MyStudentRow(
                                row,
                                onViewStudent = { selectedStudent = row; onEvent(MyStudentsUiEvent.ViewStudentRequested(row.studentId.orEmpty())) },
                                onViewAttendance = { selectedAttendanceStudent = row },
                                onViewExamResults = { selectedExamResultsStudent = row; onEvent(MyStudentsUiEvent.ViewExamResultsRequested(row.studentId.orEmpty())) },
                                onAddParentNote = {
                                    parentNotesViewModel.onEvent(ParentNotesUiEvent.StudentPrefilled(row.toParentNoteStudentPrefill().toParentNoteStudentOption()))
                                    selectedParentNoteStudent = row
                                }
                            )
                            HorizontalDivider(color = AppBorder)
                        }
                    }
                },
                footer = {
                    AdminListFooter(
                        pageText = pageFooterText(window, "students"),
                        pageIndex = safePageIndex,
                        pageCount = window.pageCount,
                        onPageChanged = { onEvent(MyStudentsUiEvent.PageChanged(it)) },
                        pageSize = state.pageSize,
                        rowsPerPageExpanded = rowsPerPageExpanded,
                        onRowsPerPageToggle = { rowsPerPageExpanded = !rowsPerPageExpanded },
                        onRowsPerPageDismiss = { rowsPerPageExpanded = false },
                        onPageSizeChanged = { onEvent(MyStudentsUiEvent.PageSizeChanged(it)) }
                    )
                }
            )
        },
        bottomAction = {}
        )

        selectedStudent?.let { row ->
            when {
                state.studentDetail != null -> StudentViewModal(
                    student = state.studentDetail,
                    onClose = { selectedStudent = null; onEvent(MyStudentsUiEvent.StudentDetailDismissed) },
                    title = "View Student Details"
                )
                state.studentDetailError.isNotBlank() -> StudentDetailStatusModal(
                    studentName = row.studentName,
                    message = state.studentDetailError,
                    error = true,
                    onClose = { selectedStudent = null; onEvent(MyStudentsUiEvent.StudentDetailDismissed) }
                )
            }
        }
        selectedAttendanceStudent?.let { row ->
            AttendanceHistoryDialog(
                student = AttendanceInsightRowUi(
                    key = row.key,
                    studentId = row.studentId.orEmpty(),
                    rollNumber = row.rollNumber,
                    studentName = row.studentName,
                    classLabel = row.classLabel,
                    attendancePercentage = row.attendancePercentage?.toInt() ?: 0,
                    totalDays = 0,
                    presentDays = 0,
                    absentDays = 0,
                    lateDays = 0,
                    excusedDays = 0,
                    performance = row.performance
                ),
                onDismiss = { selectedAttendanceStudent = null }
            )
        }
        selectedExamResultsStudent?.let { row ->
            TeacherStudentExamResultsDialog(
                student = row,
                results = state.studentExamResults,
                isLoading = state.isStudentExamResultsLoading,
                errorMessage = state.studentExamResultsError,
                onClose = { selectedExamResultsStudent = null; onEvent(MyStudentsUiEvent.StudentExamResultsDismissed) }
            )
        }
        selectedParentNoteStudent?.let { row ->
            AddParentNoteDialog(
                visible = true,
                onDismiss = { selectedParentNoteStudent = null },
                initialStudent = row.toParentNoteStudentPrefill(),
                pickerState = parentNotesState,
                onStudentSelected = { parentNotesViewModel.onEvent(ParentNotesUiEvent.StudentSelected(it)) },
                onSave = { parentNotesViewModel.onEvent(ParentNotesUiEvent.CreateRequested(it)) },
                errorMessage = parentNotesState.pickerError
            )
        }
    }
}

@Composable
private fun RowScope.MyStudentsSummaryCard(title: String, value: String, subtitle: String, icon: org.jetbrains.compose.resources.DrawableResource, accent: Color, soft: Color) {
    AdminListSummaryCard(title, value, subtitle, painterResource(icon), accent, soft, accent, modifier = Modifier.weight(1f), surfaceColor = Color.White, borderColor = AppBorder, textColor = AppNavy)
}

@Composable
private fun MyStudentsFilterPanel(
    state: MyStudentsUiState,
    onEvent: (MyStudentsUiEvent) -> Unit
) {
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .background(Color.White, RoundedCornerShape(8.dp))
            .border(1.dp, AppBorder, RoundedCornerShape(8.dp))
            .padding(horizontal = 12.dp, vertical = 12.dp),
        verticalAlignment = Alignment.Bottom,
        horizontalArrangement = Arrangement.spacedBy(14.dp)
    ) {
        Column(modifier = Modifier.weight(1.3f), verticalArrangement = Arrangement.spacedBy(7.dp)) {
            Text("Search by Name / Roll No", style = MaterialTheme.typography.labelLarge, color = AppNavy, fontWeight = FontWeight.Bold)
            BoxWithConstraints {
                AdminListSearchField(
                    value = state.searchQuery,
                    onValueChange = { onEvent(MyStudentsUiEvent.SearchChanged(it)) },
                    placeholder = "Search...",
                    width = maxWidth,
                    height = 40.dp,
                    surfaceColor = Color.White,
                    borderColor = AppBorder,
                    textColor = AppNavy,
                    cursorColor = AppPrimary
                )
            }
        }
        MyStudentsFilter(
            label = "Class",
            value = state.filters.className.ifBlank { "All" },
            options = state.classOptions.map { it.label }.distinct(),
            modifier = Modifier.weight(.9f)
        ) { value ->
            val selected = state.classOptions.firstOrNull { it.label == value }
            onEvent(
                MyStudentsUiEvent.FiltersChanged(
                    state.filters.copy(
                        className = value,
                        classSectionId = selected?.id.orEmpty()
                    )
                )
            )
        }
        MyStudentsFilter("Gender", state.filters.gender.ifBlank { "All" }, com.schoolconnect.app.repository.systemlookup.SystemLookupOptions.labels("GENDER"), Modifier.weight(.9f)) { value -> onEvent(MyStudentsUiEvent.FiltersChanged(state.filters.copy(gender = value))) }
        AppOutlinedButton(
            onClick = { onEvent(MyStudentsUiEvent.FiltersReset) },
            modifier = Modifier.width(116.dp).height(40.dp),
            shape = RoundedCornerShape(6.dp)
        ) {
            Text("Clear", color = AppPrimary, fontWeight = FontWeight.Bold)
        }
    }
}

@Composable
private fun MyStudentsFilter(label: String, value: String, options: List<String>, modifier: Modifier, onSelected: (String) -> Unit) {
    var expanded by remember { mutableStateOf(false) }
    var anchorWidth by remember { mutableStateOf(0.dp) }
    val selectionScope = rememberCoroutineScope()
    val density = LocalDensity.current
    fun select(option: String) {
        // Compose JS can finish the menu item's click-sound interaction after
        // the callback returns. Defer closing and changing the parent state so
        // the popup node remains attached while that interaction completes.
        selectionScope.launch {
            yield()
            delay(500)
            expanded = false
            onSelected(option)
        }
    }
    Column(modifier = modifier, verticalArrangement = Arrangement.spacedBy(7.dp)) {
        Text(label, style = MaterialTheme.typography.labelLarge, color = AppNavy, fontWeight = FontWeight.Bold)
        Box(modifier = Modifier.onGloballyPositioned { coordinates ->
            anchorWidth = with(density) { coordinates.size.width.toDp() }
        }) {
            OutlinedButton(onClick = { expanded = true }, modifier = Modifier.fillMaxWidth().height(44.dp), shape = RoundedCornerShape(8.dp)) {
                Row(
                    modifier = Modifier.fillMaxWidth(),
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.SpaceBetween
                ) {
                    Text(value, maxLines = 1)
                    Icon(
                        painter = painterResource(Res.drawable.chevron_down),
                        contentDescription = "Open $label options",
                        modifier = Modifier.size(18.dp),
                        tint = AppNavy
                    )
                }
            }
            AppDropdownMenu(
                expanded = expanded,
                onDismissRequest = { expanded = false },
                width = anchorWidth.takeIf { it > 0.dp },
                containerColor = Color.White,
                shape = RoundedCornerShape(8.dp),
                border = BorderStroke(1.dp, AppBorder),
                shadowElevation = 12.dp
            ) {
                DropdownMenuItem(
                    text = { Text("All", color = AppNavy) },
                    onClick = { select("") }
                )
                options.forEach { option ->
                    DropdownMenuItem(
                        text = { Text(option, color = AppNavy) },
                        onClick = { select(option) }
                    )
                }
            }
        }
    }
}

@Composable
private fun MyStudentRow(
    row: MyStudentRowUi,
    onViewStudent: () -> Unit,
    onViewAttendance: () -> Unit,
    onViewExamResults: () -> Unit,
    onAddParentNote: () -> Unit
) {
    Row(modifier = Modifier.fillMaxWidth().onViewDoubleClick(onViewStudent).heightIn(min = 52.dp).padding(horizontal = 24.dp, vertical = 4.dp), verticalAlignment = Alignment.CenterVertically) {
        MyStudentCell(row.rollNumber, .8f)
        MyStudentCell(row.studentName, 1.45f)
        MyStudentCell(row.classLabel, .9f)
        MyStudentCell(row.gender, .9f)
        MyStudentCell(row.attendancePercentage?.let { "${it.toInt()}%" } ?: "—", 1.1f)
        MyStudentCell(row.performance, 1.15f)
        var expanded by remember { mutableStateOf(false) }
        Box(Modifier.weight(.95f), contentAlignment = Alignment.Center) {
            AdminListActionIcons(onView = { expanded = false; onViewStudent() }) {
                IconButton(onClick = { expanded = true }, modifier = Modifier.size(32.dp)) { Icon(painterResource(Res.drawable.more_vertical), contentDescription = "More actions", tint = AppNavy, modifier = Modifier.size(16.dp)) }
            AdminRowActionMenu(
                sections = listOf(
                    listOf(
                        AdminRowActionItem("View Attendance", { expanded = false; onViewAttendance() }, painterResource(Res.drawable.activity_calendar), AppNavy),
                        AdminRowActionItem("View Exam Results", { expanded = false; onViewExamResults() }, painterResource(Res.drawable.stat_students), AppNavy),
                        AdminRowActionItem("Add Parent Note", { expanded = false; onAddParentNote() }, painterResource(Res.drawable.document), AppNavy)
                    )
                ),
                onDismissRequest = { expanded = false },
                expanded = expanded,
                width = 230.dp,
                surfaceColor = Color.White,
                borderColor = AppBorder,
                shadowElevation = 16.dp
            )
            }
        }
    }
}

private fun MyStudentRowUi.toParentNoteStudentPrefill(): ParentNoteStudentPrefill {
    val classParts = classLabel.split('-', limit = 2)
    return ParentNoteStudentPrefill(
        studentName = studentName,
        className = classParts.firstOrNull().orEmpty(),
        section = classParts.getOrNull(1).orEmpty(),
        studentId = studentId.orEmpty(),
        rollNumber = rollNumber
    )
}

private fun ParentNoteStudentPrefill.toParentNoteStudentOption() = ParentNoteStudentOption(
    id = studentId,
    name = studentName,
    className = className,
    sectionName = section,
    rollNumber = rollNumber
)

@Composable
private fun TeacherStudentExamResultsDialog(
    student: MyStudentRowUi,
    results: List<TeacherStudentExamResultUi>,
    isLoading: Boolean,
    errorMessage: String,
    onClose: () -> Unit
) {
    var resultsPageIndex by remember(student.studentId) { mutableStateOf(0) }
    var resultsPageSize by remember(student.studentId) { mutableStateOf(PaginationPolicy.DEFAULT_PAGE_SIZE) }
    var resultsRowsMenuExpanded by remember(student.studentId) { mutableStateOf(false) }
    val resultsWindow = pageWindow(resultsPageIndex, resultsPageSize, results.size)
    val pageResults = results.drop((resultsWindow.startIndex - 1).coerceAtLeast(0)).take(resultsWindow.pageSize)
    val averageMarks = results.mapNotNull { it.marks.toDoubleOrNull() }.takeIf { it.isNotEmpty() }
        ?.average()?.let { ((it * 10).toInt() / 10.0).toString() } ?: "—"
    val examLabels = results.map { it.examId }.distinct().withIndex().associate { it.value to "Exam ${it.index + 1}" }
    val subjectLabels = results.map { it.subjectId }.distinct().withIndex().associate { it.value to "Subject ${it.index + 1}" }
    val topSubject = results.mapNotNull { result ->
        result.marks.toDoubleOrNull()?.let { result.subjectId to it }
    }.maxByOrNull { it.second }?.first?.let { subjectLabels[it] } ?: "—"
    val absentCount = results.count { it.status.equals("Absent", ignoreCase = true) }

    AppDialogScaffold(
        onDismiss = onClose,
        size = AppDialogSize.Wide,
        colors = AppDialogDefaultColors,
        maxDialogHeight = 860.dp
    ) {
        AppDialogHeader(
            title = "Exam Results",
            subtitle = "View detailed exam results and performance for this student.",
            onClose = onClose,
            icon = Res.drawable.document,
            iconContentDescription = "Exam results",
            colors = AppDialogDefaultColors
        )
        Column(
            Modifier.fillMaxWidth().weight(1f).verticalScroll(rememberScrollState()).padding(horizontal = 24.dp, vertical = 16.dp),
            verticalArrangement = Arrangement.spacedBy(16.dp)
        ) {
            AppCard(Modifier.fillMaxWidth().border(1.dp, AppBorder, RoundedCornerShape(9.dp)), containerColor = Color.White) {
                Row(Modifier.fillMaxWidth().padding(16.dp), horizontalArrangement = Arrangement.spacedBy(24.dp), verticalAlignment = Alignment.CenterVertically) {
                    TeacherExamDialogValue("Student Name", student.studentName, Modifier.weight(1.3f))
                    TeacherExamDialogValue("Class", student.classLabel, Modifier.weight(.8f))
                    TeacherExamDialogValue("Roll No.", student.rollNumber, Modifier.weight(.7f))
                    TeacherExamDialogValue("Subject", student.examSubject.ifBlank { "Multiple subjects" }, Modifier.weight(1.1f))
                }
            }
            when {
                isLoading -> Box(Modifier.fillMaxWidth().height(180.dp), contentAlignment = Alignment.Center) { CircularProgressIndicator(color = AppPrimary) }
                errorMessage.isNotBlank() -> AppDialogErrorMessage(errorMessage)
                results.isEmpty() -> Box(Modifier.fillMaxWidth().height(180.dp), contentAlignment = Alignment.Center) { Text("No exam results found", color = AppMuted) }
                else -> {
                    Row(Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(12.dp)) {
                        TeacherExamMetric("Exams", results.map { it.examId }.distinct().size.toString(), "Published results", Res.drawable.clipboard_check, AppPrimary, AppPrimarySoft)
                        TeacherExamMetric("Average Marks", averageMarks, "Across all results", Res.drawable.health_chart, AppSuccess, AppSuccessSoft)
                        TeacherExamMetric("Top Subject", topSubject, "Highest mark", Res.drawable.chart_square, Color(0xFF6D28D9), Color(0xFFF0EDFF))
                        TeacherExamMetric("Needs Attention", if (absentCount == 0) "None" else "$absentCount absent", "Attendance status", Res.drawable.message, Color(0xFFFF7A00), Color(0xFFFFF0E3))
                    }
                    AdminListTableCard(
                        modifier = Modifier.fillMaxWidth().height(360.dp),
                        minContentWidth = 1020.dp,
                        header = {
                            Row(Modifier.fillMaxWidth().background(AppPrimarySoft).padding(12.dp), horizontalArrangement = Arrangement.spacedBy(10.dp)) {
                                TeacherExamTableHeader("Exam", 1.4f); TeacherExamTableHeader("Subject", 1.3f); TeacherExamTableHeader("Marks", .7f); TeacherExamTableHeader("Internal", .8f); TeacherExamTableHeader("Main", .7f); TeacherExamTableHeader("Grade", .7f); TeacherExamTableHeader("Status", .8f); TeacherExamTableHeader("Remarks", 1.5f)
                            }
                        },
                        body = {
                            AdminListTableBody(
                                items = pageResults,
                                key = { result -> "${result.examId}-${result.subjectId}-${result.marks}-${result.internalScore}" },
                                modifier = Modifier.fillMaxWidth().padding(8.dp),
                                verticalArrangement = Arrangement.spacedBy(8.dp)
                            ) { result ->
                                Row(Modifier.fillMaxWidth().border(1.dp, AppBorder, RoundedCornerShape(7.dp)).padding(12.dp), horizontalArrangement = Arrangement.spacedBy(10.dp), verticalAlignment = Alignment.CenterVertically) {
                                    TeacherExamTableCell(examLabels[result.examId] ?: "Exam", 1.4f); TeacherExamTableCell(subjectLabels[result.subjectId] ?: "Subject", 1.3f); TeacherExamTableCell(result.marks, .7f); TeacherExamTableCell(result.internalScore, .8f); TeacherExamTableCell(result.mainScore, .7f); TeacherExamTableCell(result.grade, .7f, if (result.grade == "—") AppMuted else AppSuccess); TeacherExamTableCell(result.status, .8f, if (result.status == "Absent") AppDanger else AppSuccess); TeacherExamTableCell(result.remarks, 1.5f)
                                }
                            }
                        },
                        footer = {
                            AdminListFooter(
                                pageText = pageFooterText(resultsWindow, "results"),
                                pageIndex = resultsWindow.pageIndex,
                                pageCount = resultsWindow.pageCount,
                                onPageChanged = { resultsPageIndex = it },
                                pageSize = resultsPageSize,
                                rowsPerPageExpanded = resultsRowsMenuExpanded,
                                onRowsPerPageToggle = { resultsRowsMenuExpanded = !resultsRowsMenuExpanded },
                                onRowsPerPageDismiss = { resultsRowsMenuExpanded = false },
                                onPageSizeChanged = {
                                    resultsPageSize = it
                                    resultsPageIndex = 0
                                    resultsRowsMenuExpanded = false
                                }
                            )
                        }
                    )
                    AppCard(Modifier.fillMaxWidth(), containerColor = AppPrimarySoft) {
                        Row(Modifier.padding(16.dp), horizontalArrangement = Arrangement.spacedBy(12.dp), verticalAlignment = Alignment.Top) {
                            Icon(painterResource(Res.drawable.message), null, tint = AppPrimary, modifier = Modifier.size(24.dp))
                            Column(verticalArrangement = Arrangement.spacedBy(4.dp)) {
                                Text("Teacher Notes", color = AppNavy, style = MaterialTheme.typography.titleMedium, fontWeight = FontWeight.Bold)
                                Text(results.map { it.remarks }.filter { it.isNotBlank() && it != "—" }.distinct().joinToString(" • ").ifBlank { "No teacher remarks recorded for this student." }, color = AppNavy)
                            }
                        }
                    }
                }
            }
        }
        AppDialogFooter(actions = listOf(AppDialogFooterAction("Close", onClose, AppDialogActionStyle.Secondary, width = 120.dp)), colors = AppDialogDefaultColors)
    }
}

@Composable
private fun RowScope.TeacherExamMetric(title: String, value: String, subtitle: String, icon: org.jetbrains.compose.resources.DrawableResource, accent: Color, background: Color) {
    AdminListSummaryCard(title, value, subtitle, painterResource(icon), accent, background, AppMuted, modifier = Modifier.weight(1f), cardHeight = 128.dp, contentPadding = androidx.compose.foundation.layout.PaddingValues(horizontal = 12.dp, vertical = 14.dp))
}

@Composable
private fun RowScope.TeacherExamTableHeader(label: String, weight: Float) {
    Text(label, Modifier.weight(weight), color = AppNavy, fontWeight = FontWeight.Bold, fontSize = 12.sp)
}

@Composable
private fun RowScope.TeacherExamTableCell(value: String, weight: Float, color: Color = AppNavy) {
    Text(value, Modifier.weight(weight), color = color, fontSize = 12.sp, maxLines = 2)
}

@Composable
private fun TeacherExamDialogValue(label: String, value: String, modifier: Modifier) {
    Column(modifier, verticalArrangement = Arrangement.spacedBy(5.dp)) {
        Text(label, color = AppMuted, style = MaterialTheme.typography.labelMedium)
        Text(value.ifBlank { "—" }, color = AppNavy, fontWeight = FontWeight.Bold)
    }
}

@Composable
private fun StudentDetailStatusModal(
    studentName: String,
    message: String,
    error: Boolean,
    onClose: () -> Unit
) {
    AppDialogScaffold(
        onDismiss = onClose,
        size = AppDialogSize.Standard,
        colors = AppDialogDefaultColors,
        maxDialogHeight = 360.dp
    ) {
        Column(
            modifier = Modifier.fillMaxWidth().padding(28.dp),
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.spacedBy(16.dp)
        ) {
            Text("View Student Details", style = MaterialTheme.typography.headlineSmall, color = AppNavy, fontWeight = FontWeight.Bold)
            Text(studentName, color = AppMuted, fontWeight = FontWeight.Medium)
            if (!error) CircularProgressIndicator(color = AppPrimary)
            Text(message, color = if (error) MyStudentsDanger else AppMuted, textAlign = TextAlign.Center)
            AppDialogFooter(
                actions = listOf(AppDialogFooterAction("Close", onClose, AppDialogActionStyle.Secondary, width = 108.dp)),
                colors = AppDialogDefaultColors
            )
        }
    }
}

@Composable
private fun RowScope.MyStudentCell(text: String, weight: Float) {
    Box(
        modifier = Modifier
            .weight(weight)
            .padding(end = 6.dp)
    ) {
        AdminListTableBodyText(text)
    }
}

private data class AttendanceRecordUi(
    val date: String,
    val day: String,
    val status: String,
    val remarks: String
)

@Composable
private fun TeacherAttendanceViewModal(
    student: MyStudentRowUi,
    onClose: () -> Unit
) {
    val attendanceViewModel = remember(student.key) { TeacherStudentAttendanceViewModel(student.studentId) }
    val attendanceState by attendanceViewModel.uiState.collectAsState()
    val lookupSnapshot by SystemLookupRepository.snapshot.collectAsState()
    val attendanceStatuses = lookupSnapshot.activeValues("ATTENDANCE_STATUS")
        .mapNotNull { it.code?.trim()?.takeIf(String::isNotBlank) }
    LaunchedEffect(Unit) {
        if (attendanceStatuses.isEmpty()) SystemLookupRepository.loadCategoryItems("ATTENDANCE_STATUS")
    }
    DisposableEffect(attendanceViewModel) {
        onDispose { attendanceViewModel.clear() }
    }
    var selectedStatus by remember { mutableStateOf("All") }
    var appliedStatus by remember { mutableStateOf("All") }
    var fromDate by remember { mutableStateOf("") }
    var toDate by remember { mutableStateOf("") }
    var rowsPerPageExpanded by remember { mutableStateOf(false) }
    val recordsListState = androidx.compose.foundation.lazy.rememberLazyListState()
    val records = attendanceState.records.map { record ->
        AttendanceRecordUi(
            date = formatAttendanceDate(record.attendanceDate),
            day = record.day.orEmpty().ifBlank { "—" },
            status = record.status.orEmpty().ifBlank { "—" },
            remarks = record.remarks.orEmpty().ifBlank { "—" }
        )
    }
    val window = pageWindow(attendanceState.pageIndex, attendanceState.pageSize, attendanceState.totalCount)
    val pageRecords = records

    LaunchedEffect(window.pageIndex, attendanceState.pageSize, attendanceState.statusFilter) {
        recordsListState.scrollToItem(0)
    }

    AppDialogScaffold(
        onDismiss = onClose,
        size = AppDialogSize.Wide,
        colors = AppDialogDefaultColors,
        maxDialogHeight = 900.dp
    ) {
        Column(modifier = Modifier.fillMaxWidth()) {
            Row(
                modifier = Modifier.fillMaxWidth().padding(start = 28.dp, end = 20.dp, top = 22.dp, bottom = 8.dp),
                horizontalArrangement = Arrangement.SpaceBetween,
                verticalAlignment = Alignment.Top
            ) {
                Column(verticalArrangement = Arrangement.spacedBy(8.dp)) {
                    Text("View Attendance", color = AppNavy, style = MaterialTheme.typography.headlineSmall, fontWeight = FontWeight.Bold)
                    Text(
                        "${student.studentName}  |  Roll No: ${student.rollNumber}  |  Class: ${student.classLabel}",
                        color = AppNavy,
                        style = MaterialTheme.typography.bodyMedium,
                        fontWeight = FontWeight.Medium
                    )
                }
                IconButton(onClick = onClose) {
                    Icon(painterResource(Res.drawable.close_x), contentDescription = "Close", tint = AppNavy)
                }
            }
            Column(
                modifier = Modifier
                    .fillMaxWidth()
                    .weight(1f)
                    .padding(horizontal = 28.dp, vertical = 16.dp),
                verticalArrangement = Arrangement.spacedBy(14.dp)
            ) {
                Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(14.dp)) {
                    AttendanceSummaryCard("Total Days", attendanceState.stats?.totalDays?.toString() ?: "—", "Days", Res.drawable.calendar, AppPrimary, AppPrimarySoft, Modifier.weight(1f))
                    AttendanceSummaryCard("Attendance %", attendanceState.stats?.attendancePercentage?.let { "${it.toInt()}%" } ?: "—", "Overall", Res.drawable.activity_calendar, AppSuccess, AppSuccessSoft, Modifier.weight(1f))
                    AttendanceSummaryCard("Present", attendanceState.stats?.presentCount?.toString() ?: "—", "Days", Res.drawable.user, AppSuccess, AppSuccessSoft, Modifier.weight(1f))
                    AttendanceSummaryCard("Absent", attendanceState.stats?.absentCount?.toString() ?: "—", "Days", Res.drawable.user, AppDanger, AppDangerSoft, Modifier.weight(1f))
                }
                if (attendanceState.isLoading) {
                    Text("Loading attendance…", color = AppMuted, modifier = Modifier.fillMaxWidth(), textAlign = TextAlign.Center)
                }
                if (attendanceState.errorMessage.isNotBlank()) {
                    AppDialogErrorMessage(attendanceState.errorMessage)
                }
                AppCard(
                    modifier = Modifier.fillMaxWidth(),
                    containerColor = Color.White
                ) {
                    Row(
                        modifier = Modifier.fillMaxWidth().padding(16.dp),
                        verticalAlignment = Alignment.Bottom,
                        horizontalArrangement = Arrangement.spacedBy(14.dp)
                    ) {
                        AttendanceDateField("From Date", fromDate, Modifier.weight(1f)) { fromDate = it }
                        AttendanceDateField("To Date", toDate, Modifier.weight(1f)) { toDate = it }
                        AttendanceStatusDropdown(selectedStatus, attendanceStatuses, Modifier.weight(1f)) { selectedStatus = it }
                        AppButton(
                            onClick = {
                                appliedStatus = selectedStatus
                                attendanceViewModel.setFilters(selectedStatus, fromDate, toDate)
                            },
                            modifier = Modifier.height(44.dp),
                            colors = ButtonDefaults.buttonColors(containerColor = AppPrimary),
                            shape = RoundedCornerShape(8.dp)
                        ) { Text("Apply", fontWeight = FontWeight.Bold) }
                        AppOutlinedButton(
                            onClick = {
                                selectedStatus = "All"
                                appliedStatus = "All"
                                fromDate = ""
                                toDate = ""
                                attendanceViewModel.setFilters("All", "", "")
                            },
                            modifier = Modifier.height(44.dp),
                            shape = RoundedCornerShape(8.dp)
                        ) { Text("Clear", color = AppNavy, fontWeight = FontWeight.Bold) }
                    }
                }
                AttendanceLegend()
                AppCard(
                    modifier = Modifier.fillMaxWidth().weight(1f),
                    containerColor = Color.White
                ) {
                    Column(modifier = Modifier.fillMaxSize()) {
                        Row(modifier = Modifier.fillMaxWidth().padding(horizontal = 16.dp, vertical = 12.dp)) {
                            AttendanceCell("Date", 1.2f, true)
                            AttendanceCell("Day", 1f, true)
                            AttendanceCell("Status", 1f, true)
                            AttendanceCell("Remarks", 2f, true)
                        }
                        HorizontalDivider(color = AppBorder)
                        DesktopAwareLazyColumn(
                            modifier = Modifier.fillMaxWidth().weight(1f),
                            state = recordsListState,
                            contentPadding = androidx.compose.foundation.layout.PaddingValues(end = 10.dp),
                            scrollbarEndOffset = (-8).dp
                        ) {
                            pageRecords.forEachIndexed { index, record ->
                                item(key = "${record.date}-$index") {
                                Row(modifier = Modifier.fillMaxWidth().padding(horizontal = 16.dp, vertical = 11.dp)) {
                                    AttendanceCell(record.date, 1.2f)
                                    AttendanceCell(record.day, 1f)
                                    AttendanceCell(record.status, 1f)
                                    AttendanceCell(record.remarks, 2f)
                                }
                                }
                                if (index != pageRecords.lastIndex) item(key = "divider-$index") { HorizontalDivider(color = AppBorder) }
                            }
                            if (pageRecords.isEmpty()) {
                                item {
                                    Text("No attendance records found", modifier = Modifier.fillMaxWidth().padding(28.dp), color = AppNavy, textAlign = TextAlign.Center)
                                }
                            }
                        }
                        HorizontalDivider(color = AppBorder)
                        AdminListFooter(
                            pageText = pageFooterText(window, "records"),
                            pageIndex = window.pageIndex,
                            pageCount = window.pageCount,
                            onPageChanged = { attendanceViewModel.setPageIndex(it) },
                            pageSize = attendanceState.pageSize,
                            rowsPerPageExpanded = rowsPerPageExpanded,
                            onRowsPerPageToggle = { rowsPerPageExpanded = !rowsPerPageExpanded },
                            onRowsPerPageDismiss = { rowsPerPageExpanded = false },
                            onPageSizeChanged = { attendanceViewModel.setPageSize(it) }
                        )
                    }
                }
            }
            HorizontalDivider(color = AppBorder)
            AppDialogFooter(
                actions = listOf(AppDialogFooterAction("Close", onClose, AppDialogActionStyle.Secondary, width = 108.dp)),
                colors = AppDialogDefaultColors,
                contentPadding = androidx.compose.foundation.layout.PaddingValues(horizontal = 24.dp)
            )
        }
    }
}

@Composable
private fun AttendanceLegend() {
    AppCard(
        modifier = Modifier.fillMaxWidth(),
        containerColor = Color.White
    ) {
        Row(
            modifier = Modifier.fillMaxWidth().padding(horizontal = 18.dp, vertical = 12.dp),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(18.dp)
        ) {
            listOf(
                "P" to "Present",
                "A" to "Absent",
                "A-M" to "Absent Morning",
                "A-A" to "Absent Afternoon"
            ).forEachIndexed { index, (code, meaning) ->
                if (index > 0) Text("|", color = AppNavy)
                Text("$code = $meaning", color = AppNavy, fontWeight = FontWeight.Medium)
            }
        }
    }
}

@Composable
private fun AttendanceSummaryCard(
    title: String,
    value: String,
    subtitle: String,
    icon: org.jetbrains.compose.resources.DrawableResource,
    accent: Color,
    accentBg: Color,
    modifier: Modifier
) {
    AdminListSummaryCard(
        title = title,
        value = value,
        subtitle = subtitle,
        icon = painterResource(icon),
        accent = accent,
        accentBg = accentBg,
        subtitleColor = accent,
        modifier = modifier,
        surfaceColor = Color.White,
        borderColor = AppBorder,
        textColor = AppNavy
    )
}

@Composable
private fun AttendanceDateField(label: String, value: String, modifier: Modifier, onValueChange: (String) -> Unit) {
    Column(modifier = modifier, verticalArrangement = Arrangement.spacedBy(7.dp)) {
        Text(label, color = AppNavy, style = MaterialTheme.typography.labelLarge, fontWeight = FontWeight.Bold)
        AppDialogDateField(
            value = value,
            onValueChange = onValueChange,
            modifier = Modifier.fillMaxWidth(),
            colors = AppDialogDefaultColors,
            fieldHeight = 44.dp,
            fontSize = MaterialTheme.typography.bodyMedium.fontSize
        )
    }
}

@Composable
private fun AttendanceStatusDropdown(value: String, options: List<String>, modifier: Modifier, onSelected: (String) -> Unit) {
    var expanded by remember { mutableStateOf(false) }
    var anchorWidth by remember { mutableStateOf(0.dp) }
    val density = LocalDensity.current
    Column(modifier = modifier, verticalArrangement = Arrangement.spacedBy(7.dp)) {
        Text("Attendance Status", color = AppNavy, style = MaterialTheme.typography.labelLarge, fontWeight = FontWeight.Bold)
        Box(modifier = Modifier.onGloballyPositioned { anchorWidth = with(density) { it.size.width.toDp() } }) {
            OutlinedButton(onClick = { expanded = true }, modifier = Modifier.fillMaxWidth().height(44.dp), shape = RoundedCornerShape(8.dp)) {
                Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.SpaceBetween, verticalAlignment = Alignment.CenterVertically) {
                    Text(value, color = AppNavy)
                    Icon(painterResource(Res.drawable.chevron_down), contentDescription = null, tint = AppNavy, modifier = Modifier.size(18.dp))
                }
            }
            AppDropdownMenu(
                expanded = expanded,
                onDismissRequest = { expanded = false },
                width = anchorWidth.takeIf { it > 0.dp } ?: 160.dp,
                containerColor = Color.White,
                shape = RoundedCornerShape(8.dp),
                border = BorderStroke(1.dp, AppBorder),
                shadowElevation = 12.dp
            ) {
                (listOf("All") + options).forEach { option ->
                    DropdownMenuItem(text = { Text(option, color = AppNavy) }, onClick = { expanded = false; onSelected(option) })
                }
            }
        }
    }
}

private fun formatAttendanceDate(value: String?): String {
    val parts = value?.trim()?.split("-") ?: return "—"
    if (parts.size != 3) return value?.ifBlank { "—" } ?: "—"
    val month = parts[1].toIntOrNull()?.let {
        listOf("Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec").getOrNull(it - 1)
    } ?: return value
    return "${parts[2].padStart(2, '0')} $month ${parts[0]}"
}

@Composable
private fun RowScope.AttendanceCell(text: String, weight: Float, header: Boolean = false) {
    Text(
        text = text,
        modifier = Modifier.weight(weight).padding(horizontal = 6.dp),
        color = AppNavy,
        fontWeight = if (header) FontWeight.Bold else FontWeight.Medium,
        style = if (header) MaterialTheme.typography.labelLarge else MaterialTheme.typography.bodyMedium
    )
}
